import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation, useParams } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";
import { useShareHolderDetails } from "./ShareHolderDetail";
import "./shareholder-form.scss";
const ShareHolderSideBar = () => {
  const location = useLocation();
  const { id: shareholderId } = useParams();
  const activeTab = location.pathname.split("/")[3] || "info";
  const { regData, loading } = useShareHolderDetails();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const hasEntityPlusAccess = regData?.entityData?.active_services?.some(
    (e) => e.name === "Entities +",
  );

  return (
    <>
      <Card className="shareholder-details-card">
        <div className="flex flex-column shareholder-profile">
          <div className="avatar-container mb-3">
            <h3>
              {getInitials(
                regData?.type === "Individual"
                  ? `${regData?.name} ${regData?.last_name}`
                  : `${regData?.legal_name}`,
              )}
            </h3>
          </div>
          {!loading ? (
            <p className="shareholder__name m-0">
              {regData?.type === "Individual"
                ? `${regData?.name} ${regData?.last_name}`
                : `${regData?.legal_name}`}
            </p>
          ) : (
            <Skeleton width="150px" height="20px" className="mr-1" />
          )}
          <p className="m-0">
            {!loading ? (
              <p className="m-0">
                {regData?.type === "Individual"
                  ? "Individual Shareholder"
                  : "Corporate Shareholder"}
              </p>
            ) : (
              <Skeleton width="150px" height="20px" className="mr-1" />
            )}
          </p>
        </div>
        {(regData?.email || (regData?.phone_code && regData?.phone)) && (
          <div className="other_datail-container">
            {regData?.email && (
              <span className="flex align-items-center  gap-2 other__detail mb-2">
                <i className="pi pi-envelope" />
                {!loading ? (
                  regData?.email
                ) : (
                  <Skeleton width="150px" height="20px" className="mr-1" />
                )}
              </span>
            )}
            {regData?.phone_code && regData?.phone && (
              <span className="flex align-items-center  gap-2 other__detail">
                <i className="pi pi-phone" />{" "}
                {!loading ? (
                  regData?.phone_code + " " + regData?.phone
                ) : (
                  <Skeleton width="150px" height="20px" className="mr-1" />
                )}
              </span>
            )}
          </div>
        )}
        <div className="flex flex-column gap-1">
          <Link
            to={`/share-holders/${shareholderId}/info`}
            className={`sidebar-align ${activeTab === "info" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Shareholder Information</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          {hasEntityPlusAccess && (
            <Link
              to={`/share-holders/${shareholderId}/address`}
              className={`sidebar-align ${activeTab === "address" ? "active-tab" : "menu-hover"}`}
            >
              <p className="sidebar-menu">Address</p>
              <span className="pi pi-angle-right icon-color"></span>
            </Link>
          )}
          <Link
            to={`/share-holders/${shareholderId}/registry`}
            className={`sidebar-align ${activeTab === "registry" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Share Registry</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          {hasEntityPlusAccess && (
            <Link
              to={`/share-holders/${shareholderId}/attachments`}
              className={`sidebar-align ${activeTab === "attachments" ? "active-tab" : "menu-hover"}`}
            >
              <p className="sidebar-menu">Attachments</p>
              <span className="pi pi-angle-right icon-color"></span>
            </Link>
          )}
        </div>
      </Card>
    </>
  );
};

export default ShareHolderSideBar;
